module.exports = __webpack_public_path__ + "static/media/journal_upload.d318acde.svg";